import { render, staticRenderFns } from "./SettlementComponent.vue?vue&type=template&id=579e3152&"
import script from "./SettlementComponent.vue?vue&type=script&lang=js&"
export * from "./SettlementComponent.vue?vue&type=script&lang=js&"
import style0 from "./SettlementComponent.vue?vue&type=style&index=0&id=579e3152&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports